import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import { SITE } from "@/lib/site";
import { WhatsAppIcon } from "@/components/WhatsAppButton";
import { SERVICES } from "@/data/services";

export const Footer = () => (
  <footer className="bg-[#1E2A78] text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div className="lg:col-span-1">
        <p className="font-display font-extrabold text-xl tracking-tight leading-tight">
          MBA Project &amp; Thesis<br />Writing Help
        </p>
        <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
          Original, confidential academic writing support for students at universities across India, Europe, North America, and the Middle East.
        </p>
        <a
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-medium text-white transition-transform duration-200 hover:-translate-y-0.5"
        >
          <WhatsAppIcon className="h-4 w-4" /> Chat on WhatsApp
        </a>
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 font-medium mb-5">Services</p>
        <ul className="space-y-3">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/services/${s.slug}`} className="text-sm text-white/70 hover:text-white transition-colors duration-200">
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 font-medium mb-5">Company</p>
        <ul className="space-y-3">
          {[
            ["/about", "About Us"],
            ["/pricing", "Pricing"],
            ["/guarantee", "Plagiarism-Free Guarantee"],
            ["/universities", "Universities We Serve"],
            ["/success-stories", "Success Stories"],
            ["/contact", "Contact Us"],
          ].map(([to, label]) => (
            <li key={to}>
              <Link to={to} className="text-sm text-white/70 hover:text-white transition-colors duration-200">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 font-medium mb-5">Contact</p>
        <ul className="space-y-4 text-sm text-white/70">
          <li className="flex items-start gap-3">
            <Phone className="h-4 w-4 mt-0.5 shrink-0" strokeWidth={1.5} />
            <a href={SITE.phoneHref} data-testid="footer-phone" className="hover:text-white transition-colors duration-200">
              {SITE.phoneDisplay}
            </a>
          </li>
          <li className="flex items-start gap-3">
            <Mail className="h-4 w-4 mt-0.5 shrink-0" strokeWidth={1.5} />
            <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-white transition-colors duration-200 break-all">
              {SITE.email}
            </a>
          </li>
          <li className="flex items-start gap-3">
            <Clock className="h-4 w-4 mt-0.5 shrink-0" strokeWidth={1.5} />
            <span>{SITE.hours}</span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} MBA Project and Thesis Writing Help. All rights reserved.
        </p>
        <p className="text-xs text-white/40">
          Academic assistance for reference and research support purposes.
        </p>
      </div>
    </div>
  </footer>
);
